export default {
      id: "common__show_disabled-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__show_disabled",
      toString: function () {
        return this.url;
      }
    }